import React, {useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {addArtImage} from "../../utils/addItems";
import {setLoading} from "../../store/reducers/modalToggler";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {RedMessage} from "../StyledComponents";
import LoadingButton from "@mui/lab/LoadingButton";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import {getImagesData} from "../../utils/apiHelper";
import {modifiedImagesList} from "../../utils/helpers";
import {setUserImagesList} from "../../store/reducers/userImagesListSlice";
import Stack from "@mui/material/Stack";

let pageCount = 1

function ReplaceModelContent({setOpenReplaceModal}) {
    const imageCollection = useSelector((state) => state.userImagesList).userImagesList;
    const {canvas} = useSelector((state) => state.canvas);
    const activeSheet = useSelector((state) => state.activeSheet).sheet;
    const { isLoggedIn } = useSelector((state) => state.loginSlice);
    const [btnLoading, setBtnLoading] = useState(false);
    const [noDataMsg, setNoDataMsg] = useState(false);

    const dispatch = useDispatch()

    const replaceImage = (imageUrl, id) => {
        const currentImage = canvas.getActiveObject();
        const index = canvas.getObjects().indexOf(currentImage);
        setOpenReplaceModal(false)
        dispatch(setLoading(true));
        if(currentImage){
            addArtImage(imageUrl, currentImage.left, currentImage.top, canvas, id, activeSheet).then((newImage) => {
                canvas.remove(currentImage);
                canvas.moveTo(newImage, index);
                canvas.renderAll();
                dispatch(setLoading(false));
            })
        }
        else {
            addArtImage(imageUrl, 100, 100, canvas, id, activeSheet).then((newImage) => {
                canvas.renderAll();
                dispatch(setLoading(false));
            })
        }
    }

    const loadMoreImages = () => {
        if (isLoggedIn) {
            setBtnLoading(true)
            getImagesData('', pageCount + 1).then(async (res) => {
                const data = await modifiedImagesList(res, activeSheet);
                dispatch(setUserImagesList([...imageCollection, ...data]));
                setBtnLoading(false)
                pageCount = pageCount + 1
            })
                .catch(err=>{
                    setNoDataMsg(true)
                    setTimeout(() => {
                        setNoDataMsg(false);
                    }, 4000);
                    setBtnLoading(false)
                });
        }
    }

    const replaceBaseUrl = (originalUrl) => {
        const extractedBaseUrl = originalUrl.match(/(https?:\/\/[^\/]+\/)/)[0];
        return originalUrl.replace(extractedBaseUrl, `${process.env.REACT_APP_OnFlyResize}/fit-in/100x100/`);
    }
    return (
        <Stack justifyContent='center'>
            <div className="images-grid-image-panel gallery-content gnr-m-0 image-grid">
                {
                    imageCollection && imageCollection.map((item, key) => (
                        <div
                            className={`image-grid__images ${item.loading ? 'loading-image' : ''}`}
                            key={key}>

                            {
                                item.loading ?
                                    (
                                        <div className="progress progress-width">
                                            <div
                                                className="progress-bar"
                                                role="progressbar"
                                                style={{width: `${item.progress}%`}}
                                                aria-valuenow="25"
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                            >
                                                {item.progress - 1}
                                                %
                                            </div>
                                        </div>
                                    ) :
                                    <>
                                        <LazyLoadImage
                                            className="replace-modal-image"
                                            style={{objectFit: 'cover', cursor: 'pointer'}}
                                            src={replaceBaseUrl(item.imageUrl)}
                                            onClick={() => replaceImage(item.compressedUrl ? `${process.env.REACT_APP_cdnURL}/` + item.compressedUrl : item.imageUrl, item.id)}
                                            height={120}
                                            width={120}
                                            alt="imageOb"
                                        />
                                    </>
                            }

                        </div>
                    ))
                }
            </div>
            {noDataMsg && <RedMessage className="">No more data</RedMessage>}
            {imageCollection.length > 0 &&
            <LoadingButton sx={{mt: 3}}
                           onClick={loadMoreImages}
                           loading={btnLoading}
                           loadingPosition="end"
                           endIcon={<PublishedWithChangesIcon />}
                           variant="contained"
            >
                <span>Load more</span>
            </LoadingButton>
            }
        </Stack>
    );
}

export default ReplaceModelContent;